import { useDispatch, useSelector } from "react-redux";
import { useGetTechnicianWorksMutation } from "../../../Store/Builder/schedule.api";
import moment from "moment";
import showToast from "../../Hooks/toast";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import { useState } from "react";

const useGetTechnicianCalendar = () => {
  const dispatch = useDispatch();
  const { lat, lon } = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData
  );
  const [getCalendar] = useGetTechnicianWorksMutation();
  const [list, setList] = useState(null);

  const get = (date, item) => {
    dispatch(setLoader(true));
    const params = {
      lon: lon ?? item?.lon,
      lat: lat ?? item?.lat,
      start: moment(date[0]).format("YYYY-MM-DD"),
      end: moment(date[1]).format("YYYY-MM-DD"),
      id: item?.id,
    };
    getCalendar(params)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        setList(res);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
    list,
    setList,
  };
};

export default useGetTechnicianCalendar;
